import { useState, useRef, useEffect } from 'react';
import closeicon from "../img/close.svg";


import { useParams, useNavigate } from 'react-router-dom';

import ioslocation1 from "../img/locationhowto/location-howto-ios-1.png";
import ioslocation2 from "../img/locationhowto/location-howto-ios-2.png";
import ioslocation3 from "../img/locationhowto/location-howto-ios-3.png";
import androidlocation1 from "../img/locationhowto/location-howto-android-1.png";
import androidlocation2 from "../img/locationhowto/location-howto-android-2.png";
import androidlocation3 from "../img/locationhowto/location-howto-android-3.png";


function ModalLocationInfo(props) {

  const navigate = useNavigate();

  const [tab, setTab] = useState("ios");

  useEffect(() => {
    const ua = navigator.userAgent.toLowerCase();
    if (/android/.test(ua)) {
      setTab("android");
    }
  }, []);

  let lang = props.lang;

  const tl = {
    headline: {
      de: "Standort freigeben",
      en: "Enable your location",
      it: "Abilita la tua posizione"
    },
    subtext: {
      de: "Um Stationen freizuschalten musst du dich ihnen nähern. Dafür benötigt die App deinen Standort.",
      en: "To unlock the stations you need to move close to them, and for that the app needs to know your location.",
      it: "Per sbloccare le stazioni devi avvicinarti a loro, e per questo l'app ha bisogno di conoscere la tua posizione."
    },
    iphone: {
      de: ["Öffne iPhone Einstellungen → Datenschutz & Sicherheit → Ortungsdienste", "Schalte Ortungsdienste ein. Scrolle nach unten und wähle deinen Browser (Safari-Websites, Chrome usw.)", "Wähle 'Beim Verwenden der App' und aktiviere 'Genauer Standort'"],
      en: ["Open iPhone Settings → Privacy & Security → Location Services", "Turn Location Services On. Then scroll down and select your browser (Safari Websites, Chrome, etc.)", "Select 'While Using the App' and turn Precise Location On"],
      it: ["Apri Impostazioni → Privacy e sicurezza → Localizzazione", "Attiva Servizi di localizzazione. Poi scorri in basso e seleziona il tuo browser (Siti web Safari, Chrome, ecc.)", "Seleziona “Durante l’uso dell’app” e attiva “Posizione precisa”"]
    },
    android: {
      de: ["Stelle sicher, dass der Standort in deinen Haupteinstellungen eingeschaltet ist.", "Tippe auf das Symbol in der Adressleiste des Browsers. Gehe dann zu Berechtigungen → Standort und erlaube den Zugriff.", "Stelle auch sicher, dass dein Browser (z. B. Chrome) die Standortberechtigung hat. Gehe dazu in die Systemeinstellungen unter Apps."],
      en: ["Make sure Location is turned on in your phone's main settings.", "Tap the icon in your browser's address bar. Then go to Permissions → Location and allow access.", "Also make sure your browser (e.g. Chrome) has location permission. To check, go to Apps in your system settings."],
      it: ["Assicurati che la posizione sia attivata nelle impostazioni principali del telefono.", "Tocca l'icona nella barra degli indirizzi del browser. Poi vai su Autorizzazioni → Posizione e consenti l'accesso.", "Assicurati anche che il tuo browser (es. Chrome) abbia l'autorizzazione per la posizione. Per verificarlo, vai su App nelle impostazioni di sistema."]
    },
    reload: {
      de: "Neu laden wenn fertig",
      en: "Reload page when done",
      it: "Ricarica la pagina quando hai finito"
    }
  }

  const images = [
    ioslocation1,
    ioslocation2,
    ioslocation3
  ]

  const androidImages = [
    androidlocation1,
    androidlocation2,
    androidlocation3
  ]


  return (
    <div className={`modalstationprogress ${props.open ? null : "modalstationprogressclosed"}`} >
      <div className="modalstationprogressbackground" onClick={() => props.onClose()}></div>
      <div className="modallocationinner" >


        <img src={closeicon} className='modalstationprogressclose' onClick={() => props.onClose()} />

        <div className="modallocationinnercontent">
          <h2>{tl.headline[lang]}</h2>
          <p>{tl.subtext[lang]}</p>

          <div className='tabcontainer'>
            <div className={`tabitem ${tab == "ios" && "tabitemactive"}`} onClick={() => setTab("ios")}>iPhone</div>
            <div className={`tabitem ${tab == "android" && "tabitemactive"}`} onClick={() => setTab("android")}>Android</div>
          </div>

          {
            tab == "ios" &&
            <div className='locationhowtocontent'>
              
                {
                  tl.iphone[lang].map((obj, index) => 
                  <div key={index}>
                    <p><b>{index + 1}.</b> {obj}</p>
                    <img src={images[index]} />
                    </div>
                )
                }
              {/*<img src={ioslocationicon} style={{ width: '100%', maxWidth: 280, marginTop: 12 }} />*/}
            </div>

          }
          {
            tab == "android" &&
            <div className='locationhowtocontent'>
                {
                  tl.android[lang].map((obj, index) =>
                  <div key={index}>
                    <p><b>{index + 1}.</b> {obj}</p>
                    <img src={androidImages[index]} />
                    </div>
                )
                }
            </div>
          }

          <div className='button-primary' style={{ marginTop: 24 }} onClick={() => window.location.reload()}>{tl.reload[lang]}</div>

        </div>

      </div>
    </div>
  );
}

export default ModalLocationInfo;
